import { combineReducers } from "redux";
import containerReducer from "external/container/reducer";
import { externalReportsReducer } from "external/reports/reducer";
export const externalReducer = combineReducers({
    container: containerReducer,
    reports: externalReportsReducer
});
